import type { ReactNode } from 'react';

type SettingRowProps = {
  label: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  children: ReactNode;
};

const SettingRow = ({ label, description, disabled = false, children }: SettingRowProps) => {
  const rowClass = disabled ? 'permission-row permission-row--disabled' : 'permission-row';

  return (
    <div className={rowClass}>
      <div className="permission-row__label-wrap">
        <span className="permission-row__label">{label}</span>
        {description !== undefined && description !== null && description !== '' ? (
          <span className="permission-row__description">{description}</span>
        ) : null}
      </div>
      <div className="permission-row__select">{children}</div>
    </div>
  );
};

export default SettingRow;
